import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Snackbar from '@material-ui/core/Snackbar'
import IconButton from '@material-ui/core/IconButton'
import IconClose from '@material-ui/icons/Close'
import amber from '@material-ui/core/colors/amber'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'

import { removeSnack } from '../actions/app'


const styles = theme => ({
  snackClose: {
    padding: theme.spacing(1 / 2),
  },
  snack: {
    color: 'white',
    cursor: 'pointer',
  },
  snackError: {
    backgroundColor: amber[700],
  },
})


const createOnCloseSnackbar = removeSnackAction => (event, reason) => {
  if (reason !== 'clickaway') {
    removeSnackAction()
  }
}


const Notification = ({
  snack,
  classes,
  snackUrl,
  snackType,
  ...props
}) => {
  const handleClick = () => {
    if (snackUrl) {
      window.location.href = snackUrl
    } else {
      props.removeSnack()
    }
  }

  return (
    <Snackbar
      open={!!snack}
      variant={snackType}
      onClick={handleClick}
      autoHideDuration={7500}
      onExited={props.removeSnack}
      onClose={createOnCloseSnackbar(props.removeSnack)}
      message={<span id="snack-message">{snack}</span>}
      ContentProps={{
        'aria-describedby': 'snack-message',
        className: classNames(classes.snack, {
          [classes.snackError]: snackType === 'error',
        }),
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      action={[(
        <IconButton
          key="close"
          color="inherit"
          aria-label="Close"
          className={classes.snackClose}
          onClick={props.removeSnack}
        >
          <IconClose />
        </IconButton>
      )]}
    />
  )
}


Notification.propTypes = {
  snack: PropTypes.string,
  snackUrl: PropTypes.string,
  snackType: PropTypes.string,
  classes: PropTypes.object.isRequired,
  removeSnack: PropTypes.func.isRequired,
}


const mapStateToProps = state => ({
  snack: state.app.snack,
  snackUrl: state.app.snackUrl,
  snackType: state.app.snackType,
})


export default connect(mapStateToProps, {
  removeSnack,
})(withStyles(styles)(Notification))
